<script setup lang="ts">
import { useRoute } from 'vue-router'
import { useDisplay } from 'vuetify';
const route = useRoute();
const { xs, smAndUp } = useDisplay();
</script>

<template>
  <v-app-bar color="primary" height="auto" style="position: fixed; top: 0; width: 100%; z-index: 1000;" scroll-behavior="hide">
    <v-container fluid>
      <v-row class="mx-n4 mt-n4">
        <v-col>
          <v-app-bar-title>Vanglateenistus</v-app-bar-title>
        </v-col>
      </v-row>
      <v-row class="bg-white mx-n4 mb-n4">
        <v-col>
          <v-app-bar-title>Kriminaalhooldusportaal</v-app-bar-title>
        </v-col>
        <v-col class="pa-0 d-flex" style="min-height: 32px" cols="12" sm="auto">
          <v-spacer v-if="smAndUp" />
          <v-tabs
              class="elevation-5"
              height="100%"
              :v-model="route.path"
              selected-class="bg-primary"
              hide-slider
              :grow="xs"
          >
            <v-tab to="/" exact>AVALEHT</v-tab>
            <v-tab to="/ligipaasetavus" exact>Ligipääsetavus</v-tab>
          </v-tabs>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<style scoped>

</style>